import { render, staticRenderFns } from "./NewRealEstateBuildingCalculatedView.vue?vue&type=template&id=4256b583&"
import script from "./NewRealEstateBuildingCalculatedView.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateBuildingCalculatedView.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateBuildingCalculatedView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports